<div style="padding-top: 24px;" *ngIf="role=='viewer'">
</div>
<div class="bannerFeedback" *ngIf="!(showActiveQuestionnaireBanner&&dataLoaded&&timeLefActiveQuestionnaire) && !(showNextQuestionnaireBanner&&dataLoaded&&timeLeftNextQuestionnaire)&&(role!='viewer')">
    <div class="textContainer">
        <div class="firstRow">
             <img style="width: 25px; margin-right: 5px;" src="assets/images/mdiCreation.png"/>
             <p class="text1">
            {{'bannerFeedback.feedback' | translate}}
        </p>
        </div>
        
        <p class="text2">
            {{'bannerFeedback.feedbackInstructions' | translate}}
        </p>
    </div>
    <div style="width: 120px;">
         <button mat-button class="orangeButton mdc-button mat-mdc-button mat-unthemed mat-mdc-button-base" style="font-size: 12px;" (click)="openLink('https://forms.gle/PVrUexvcQtixm2PR8',$event)">{{'bannerFeedback.answer' | translate}}
         </button>
    </div>
</div>

<ng-container *ngIf="showNextQuestionnaireBanner&&dataLoaded&&timeLeftNextQuestionnaire&&(role!='viewer')">
<div [@slideInOut]="nextQuestionnairesStatus" class="bannerFeedback" [ngStyle]="{'margin-bottom': showActiveQuestionnaireBanner ? '0px' : '20px' }">
    <div class="textContainer">
        <div class="firstRow">
             <img style="width: 25px; margin-right: 5px;" src="assets/images/mdiGauge.png"/>
             <p class="text1">
            {{'bannerFeedback.upcomingQuestionnaire' | translate}}
        </p>
        </div>
        
        <p class="text2" *ngIf="nextQuestionnairesStatus=='expanded'">
           <span>{{'bannerFeedback.upcomingQuestionnaireInstructions' | translate}} 
            
            <!-- schools (for admins) -->
            <span *ngIf="role!=''&&role=='admin'">{{'bannerFeedback.clickHereSchools' | translate}}:
            <span *ngFor="let element of nextActiveQuestionnairesTwoWeeks; let i = index">
                <span style="text-decoration: underline; cursor: pointer;" (click)="navigateToSection('/section/home/school/'+element.schoolId)">{{element.schoolName}}</span><span style="text-decoration: none;" *ngIf="i!=(nextActiveQuestionnairesTwoWeeks.length-1)">, </span>
            </span>
            </span>
            <!-- classes (for educators) -->
            <span *ngIf="role!=''&&role=='educator'">{{'bannerFeedback.clickHereClasses' | translate}}:
            <span *ngFor="let element of nextActiveQuestionnairesTwoWeeks; let i = index">
                <span style="text-decoration: underline; cursor: pointer;" (click)="navigateToSection('/section/intervention/'+element.id)">{{element.name}}</span><span style="text-decoration: none;" *ngIf="i!=(nextActiveQuestionnairesTwoWeeks.length-1)">, </span>
            </span>
            </span>


            </span>
        </p>
    </div>
    <div class="countdown" *ngIf="timeLeftNextQuestionnaire">
        <p id="countdown" style="margin: 0px">{{ timeLeftNextQuestionnaire.days }} {{'bannerFeedback.days' | translate}} {{ timeLeftNextQuestionnaire.hours }} {{'bannerFeedback.h' | translate}} {{ timeLeftNextQuestionnaire.minutes }} {{'bannerFeedback.min' | translate}}</p>
        <img style="width: 20px; margin-left: 10px; cursor: pointer;" src="assets/images/buttonArrow.png" (click)="collapse('nextQuestionnaires')" [ngStyle]="{'transform': nextQuestionnairesStatus=='expanded' ? 'rotate(180deg)' : 'rotate(0deg)' }" />
    </div>

    
</div>
</ng-container>

<ng-container *ngIf="showActiveQuestionnaireBanner&&dataLoaded&&timeLefActiveQuestionnaire&&(role!='viewer')">
<div [@slideInOut]="activeQuestionnairesStatus" class="bannerFeedback"  style="background-color: #9e4d94;">
    <div class="textContainer">
        <div class="firstRow">
             <img style="width: 25px; margin-right: 5px;" src="assets/images/mdiGauge.png"/>
             <p class="text1">
            {{'bannerFeedback.pendingQuestionnaire' | translate}}
        </p>
        </div>
        
        <p class="text2" *ngIf="activeQuestionnairesStatus=='expanded'">
           <span>{{'bannerFeedback.pendingQuestionnaireInstructions' | translate}} 
            
            <!-- schools (for admins) -->
            <span *ngIf="role!=''&&role=='admin'">{{'bannerFeedback.clickHereSchools' | translate}}:
            <span *ngFor="let element of currentActiveQuestionnaires; let i = index">
                <span style="text-decoration: underline; cursor: pointer;" (click)="navigateToSection('/section/home/school/'+element.schoolId)">{{element.schoolName}}</span><span style="text-decoration: none;" *ngIf="i!=(currentActiveQuestionnaires.length-1)">, </span>
            </span>
            </span>
            <!-- classes (for educators) -->
            <span *ngIf="role!=''&&role=='educator'">{{'bannerFeedback.clickHereClasses' | translate}}:
            <span *ngFor="let element of currentActiveQuestionnaires; let i = index">
                <span style="text-decoration: underline; cursor: pointer;" (click)="navigateToSection('/section/intervention/'+element.id)">{{element.name}}</span><span style="text-decoration: none;" *ngIf="i!=(currentActiveQuestionnaires.length-1)">, </span>
            </span>
            </span>


            </span>
        </p>
    </div>
    <div class="countdown" *ngIf="timeLefActiveQuestionnaire">
        <p id="countdown" style="margin: 0px" >{{ timeLefActiveQuestionnaire.days }} {{'bannerFeedback.days' | translate}} {{ timeLefActiveQuestionnaire.hours }} {{'bannerFeedback.h' | translate}} {{ timeLefActiveQuestionnaire.minutes }} {{'bannerFeedback.min' | translate}}</p>
        <img style="width: 20px; margin-left: 10px; cursor: pointer;" src="assets/images/buttonArrow.png" (click)="collapse('activeQuestionnaires')" [ngStyle]="{'transform': activeQuestionnairesStatus=='expanded' ? 'rotate(180deg)' : 'rotate(0deg)' }" />
    </div>

    
</div>
</ng-container> 





